export default {
  menu: {
    menu: 'Menu',
    applications: 'Wnioski',
    specialInvoicingApplication: 'Wnioski o niestandardowe fakturowanie',
    purchaseInvoicesToBeClarified: 'Faktury zakupu do wyjaśnienia',
    purchaseInvoicesTv: 'Faktury TV',
    estimateItemPurchaseDeficiencies: 'Wyjaśnienia braków FVZ',
    orders: 'Zamówienia',
    ordersExecutions: 'Realizacje zamówień',
    finance: 'Finanse',
    salesInvoices: 'Faktury sprzedaży',
    salesInvoicesReadyToCorrection: 'Faktury sprzedaży do skorygowania',
    purchaseInvoices: 'Faktury zakupu',
    verifications: 'Weryfikacja',
    imports: 'Importy',
    specialInvoicingDecision: 'Wnioski o niestandardowe fakturowanie',
    blockade: 'Blokady',
    contracts: 'Zlecenia',
    contractsTV: 'Zlecenia TV',
    contractsToSign: 'Podpisywanie zleceń',
    sendFVSToClients: 'Wysyłka FVS do klientów',
    exportFVZToXml: 'Eksport FVZ do XML',
    exportFVSToXml: 'Eksport FVS do XML',
    exportFVSToSymphony: 'Eksport FVS do Symfonii Handel',
    clientsWithSymphony: 'Kontrahenci - Symfonia',
    errorsEOD: 'Błędy EOD',
    reportsFinance: 'Zestawienia finanse',
    salesInvoicing: 'Sprzedaż - zafakturowanie',
    reportsFinanceAdministration: 'Finanse - administracja',
    bankAccounts: 'Konta bankowe',
    clients: 'Kontrahenci',
    clientsList: 'Lista kontrahentów',
    purchasers: 'Zamawiający',
    positions: 'Pozycje profili',
    budgets: 'Budżety',
    brands: 'Brandy',
    administrations: 'Administracja',
    companies: 'Spółki',
    employees: 'Pracownicy',
    teams: 'Zespoły',
    oneToolTeams: 'Zespoły OneTool',
    profiles: 'Profile mediaplanów',
    profileCategories: 'Kategorie profili',
    dictionaries: 'Słowniki',
    calendar: 'Kalendarz',
    roles: 'Role',
    employeesRoles: 'Uprawnienia',
    emailConfigs: 'Konfiguracja maili',
    jobConfig: 'Konfiguracja zadań cyklicznych',
    params: 'Parametry systemu',
    tooltips: 'Tooltipy',
    excelConfig: 'Konfiguracja importu',
    reports: 'Zestawienia',
    help: 'Pomoc',
    instructions: 'Instrukcje obsługi',
    procedures: 'Procedury',
    documentation: 'Dokumentacja',
    logout: 'Wyloguj',
    authorized: 'Upoważnieni',
    downloadsDocuments: 'Pobieranie dokumentów',
    timeLineHints: 'Oś czasu - wskazówki',
    recommendedPublishers: 'Rekomendowani dostawcy',
    surveys: 'Ankiety',
    surveysList: 'Lista ankiet',
    clientSurveysWaiting: 'Oczekujące',
    clientSurveyResults: 'Wyniki',
    timeLineSteps: 'Oś czasu - kroki',
    clientGroups: 'Grupy kontrahentów',
    surveyClientsList: 'Lista kontrahentów',
    emailsList: 'Lista wysłanych e-maili',
  },
  docs: {
    addingPurchaseInvoices: 'Dodawanie i akceptacja faktur zakupu',
    settlementWithholdingTax: 'Rozliczanie podatku u źródła',
    orderFulfillment: 'Realizacja zamówienia (zespoły realizujące)',
    acceptanceInvoices: 'Akceptacja faktur',
  },
  system: {
    noPermissions: 'Brak wymaganych uprawnień',
    unknownError: 'Nieznany błąd',
    cannotBePerformed: 'Nie można wykonać tej operacji',
    increaseRights:
      'W celu podwyższenia uprawnień prosimy o kontakt z administracją.',
    badCompany: 'Niezgodna spółka',
    badCompanyLongText:
      'Spółka, w której obecnie pracujesz, nie może obsługiwać wybranego obiektu.',
    rightCompany: 'Obiekt jest obsługiwany przez spółkę:',
    applicationLinkRedirectsToCompany: 'Link przekierowuje do spółki',
    applicationChangeCompanyInfo:
      'Zmień spółkę, jeśli chcesz obsługiwać wnioski w innej spółce.',
    waitingForConnection: 'Czekamy na przywrócenie połączenia...',
    problemsWithConnection:
      '⛈️ Kłopoty z połączeniem - dane mogą nie zostać zapisane!',
    connectionRestored: '☀️ Połączenie przywrócone',
    cannotLoad: 'Strona nie może być załadowana',
    writingError: 'Błąd przy zapisie.',
    savedChanges: 'Zmiany zostały zapisane.',
    copyClipboardError: 'Coś poszło nie tak przy kopiowaniu tekstu do schowka.',
    copyClipboard: 'Kopiuj do schowka',
    ctrlV: 'Skopiowano do schowka. Wklej skrótem Ctrl+V.',
    serverNotResponse: 'Serwer nie odpowiada... ',
    fileTooLarge: 'Plik jest zbyt duży, aby go wysłać.',
    login: 'LOGOWANIE',
    loginError: 'Błąd podczas logowania: ',
  },
} as const;
